import React from 'react';
import { UnauthorizedIcon } from '../../assets/images';
import './styles.scss';
function FleetExpired() {
  return (
    <div className="unauth_page">
      <div className="unauth_content">
        <UnauthorizedIcon alt="ABB" />
        <div>
          <div className="text-center">
            Sorry! Your access has expired. <br />
            Please contact ABB to renew your access.
          </div>
        </div>
      </div>
    </div>
  );
}

export default FleetExpired;
